import { GameProposal, Player } from '../types';

export const validatePlayerCategory = (game: GameProposal, player: Player): { isValid: boolean; message: string } => {
  if (player.isTemporary) {
    return { isValid: true, message: '' };
  }

  if (game.sport === 'padel') {
    if (!player.padel_category) {
      return {
        isValid: false,
        message: 'To join this game, you need to define your Padel category in your profile.'
      };
    }

    const playerCategory = String(player.padel_category);
    const allowedCategories = Array.isArray(game.requiredCategories)
      ? game.requiredCategories
      : game.requiredCategories?.padel || [];

    if (allowedCategories.length > 0 && !allowedCategories.includes(playerCategory)) {
      return {
        isValid: false,
        message: `This game is only for players with categories: ${allowedCategories.join(', ')}`
      };
    }
  }

  // Fix the sport check for Beach Tennis
  if (game.sport === 'beach-tennis') {
    if (!player.beach_tennis_category) {
      return {
        isValid: false,
        message: 'To join this game, you need to define your Beach Tennis category in your profile.'
      };
    }

    const playerCategory = String(player.beach_tennis_category);
    const allowedCategories = Array.isArray(game.requiredCategories)
      ? game.requiredCategories
      : game.requiredCategories?.beachTennis || [];

    if (allowedCategories.length > 0 && !allowedCategories.includes(playerCategory)) {
      return {
        isValid: false,
        message: `This game is only for players with categories: ${allowedCategories.join(', ')}`
      };
    }
  }

  return { isValid: true, message: '' };
};